var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomExperiences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 60 60",
    fill: "#260e00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0002,59.093c-10.6582,0-19.3291-8.6719-19.3291-19.3301s8.6709-19.3291,19.3291-19.3291,19.3291,8.6709,19.3291,19.3291-8.6709,19.3301-19.3291,19.3301ZM50.0002,23.8362c-8.7822,0-15.9268,7.1445-15.9268,15.9268s7.1445,15.9277,15.9268,15.9277,15.9268-7.1445,15.9268-15.9277-7.1445-15.9268-15.9268-15.9268Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8543,78.4094c-.0613-7.9236-1.0067-12.6587-7.393-16.055-.3037-.1615-.5026-.4743-.5026-.8183v-.147c0-.6397.6359-1.0952,1.235-.871,5.0396,1.8864,10.4614,1.8915,15.503.0121.5995-.2235,1.2349.2331,1.2338.8729l-.0003.1621c-.0005.3285-.1834.6309-.4666.7973-6.5457,3.8472-7.3597,8.3373-7.4121,16.0458-.0035.51-.4149.9277-.925.9283l-.3456.0004c-.5106.0006-.9228-.4172-.9268-.9278Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.054,53.7073c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7363,51.6674c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8964,47.3784c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6712,43.4221c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7626,36.5669c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0756,47.5894c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0618,41.4469c2.5837,0,2.588-4.0154,0-4.0154-2.5837,0-2.588,4.0154,0,4.0154h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomExperiences);
export default __webpack_public_path__ + "static/media/custom_experiences.c30b2ef7269b7cd7c9d3eb5713d35227.svg";
export { ForwardRef as ReactComponent };